/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import Flag from '@atlaskit/flag/flag'` instead.
 */
export { default } from './flag';
/**
 * @deprecated Use `import AutoDismissFlag from '@atlaskit/flag/auto-dismiss-flag'` instead.
 */
export { default as AutoDismissFlag } from './auto-dismiss-flag';
/**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */
export { default as FlagGroup } from './flag-group';
/**
 * @deprecated Use `import { FlagsProvider } from '@atlaskit/flag/flags-provider'` instead.
 */
export { FlagsProvider } from './flags-provider';
/**
 * @deprecated Use `import { useFlags } from '@atlaskit/flag/use-flags'` instead.
 */
export { useFlags } from './use-flags';
/**
 * @deprecated Use `import { withFlagsProvider } from '@atlaskit/flag/with-flags-provider'` instead.
 */
export { withFlagsProvider } from './with-flags-provider';
/**
 * @deprecated Use `import type { CreateFlagArgs, DismissFn, FlagAPI, FlagArgs } from '@atlaskit/flag/flag-provider'` instead.
 */
export type { CreateFlagArgs, DismissFn, FlagAPI, FlagArgs } from './flag-provider';
/**
 * @deprecated Use `import type { FlagProps, ActionsType, AppearanceTypes } from '@atlaskit/flag/types'` instead.
 */
export type { FlagProps, ActionsType, AppearanceTypes } from './types';
